export const environment = {
  env: 'dev',
  production: false,
  excludingUrl: ['https://brimmastorage.blob.core.windows.net', 'https://brimmavalliasaasprodsa.blob.core.windows.net'],
  applicationName: 'Vallia Docflow',
};
